import React, { useState, useEffect } from "react";

// Composant pour un élément de sous-menu imbriqué
function NestedSubMenu({ title, icon, children, isActive }) {
  const [isOpen, setIsOpen] = useState(isActive);

  // Mettre à jour l'état d'ouverture si isActive change
  useEffect(() => {
    if (isActive) {
      setIsOpen(true);
    }
  }, [isActive]);

  // Fonction pour vérifier si au moins un enfant est accessible
  const hasAccessibleChildren = () => {
    const childrenArray = React.Children.toArray(children);
    
    // Pour simplifier et éviter les problèmes de production,
    // nous allons simplement vérifier si des enfants existent
    // Le ConditionalRender se chargera de l'affichage conditionnel
    return childrenArray.length > 0;
  };

  // Ne pas afficher le sous-menu s'il n'y a pas d'enfants accessibles
  if (!hasAccessibleChildren()) {
    return null;
  }

  return (
    <li className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-between w-full p-2.5 text-left rounded-lg hover:bg-gray-100 group transition-all duration-200 ${
          isActive
            ? "bg-orange-50 text-orange-500 font-medium"
            : isOpen
            ? "bg-gray-50 text-gray-700 font-medium"
            : "text-gray-700"
        }`}
        aria-expanded={isOpen}
      >
        <div className="flex items-center space-x-3">
          <span
            className={`transition-colors duration-200 flex-shrink-0 ${
              isActive
                ? "text-orange-500"
                : "text-gray-500 group-hover:text-gray-700"
            }`}
          >
            {icon}
          </span>
          <span className="text-left truncate text-sm">{title}</span>
        </div>
        <svg
          className={`w-3.5 h-3.5 transition-all duration-200 ${
            isActive ? "text-orange-500" : "text-gray-400"
          } ${isOpen ? "rotate-180" : ""}`}
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {isOpen && (
        <ul className="py-1 ml-4 space-y-1 border-l-2 border-gray-100 pl-2">
          {children}
        </ul>
      )}
    </li>
  );
}

export default NestedSubMenu;
